import { BreadcrumbGroup } from '@cloudscape-design/components';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Breadcrumb navigation component rendered below the top nav on non-list views.
 * Derives segments from the current route path. Max 3 levels.
 *
 * Requirements: 13.1, 13.2, 13.3, 13.4, 13.5
 */
export function BreadcrumbNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const segments = buildBreadcrumbs(location.pathname);

  if (segments.length <= 1) return null; // Don't show on list view (root)

  return (
    <BreadcrumbGroup
      items={segments}
      onFollow={(event) => {
        event.preventDefault();
        navigate(event.detail.href);
      }}
    />
  );
}

interface BreadcrumbItem {
  text: string;
  href: string;
}

function buildBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [{ text: 'Configurations', href: '/' }];

  if (pathname === '/') return items;

  if (pathname === '/configs/new') {
    items.push({ text: 'Create Configuration', href: '/configs/new' });
  } else if (pathname === '/pending-deletions') {
    items.push({ text: 'Pending Deletions', href: '/pending-deletions' });
  } else if (pathname.match(/^\/configs\/[^/]+\/edit$/)) {
    items.push({ text: 'Edit Configuration', href: pathname });
  } else if (pathname.match(/^\/configs\/[^/]+$/)) {
    items.push({ text: 'Configuration Detail', href: pathname });
  }

  return items;
}
